{
	"backToStartPage": "Volver a la página de inicio",
	"transactionDetailsTitle": "Detalles de la transacción",
	"btnVerifyTransactions": "Verificar transacciones",
	"kpi": {
		"date": "Fecha",
		"quantity": "Cantidad",
		"carbonReductions": "Reducciones de carbono"
	},
	"verifyTransactionModal": {
		"title": "Verificar transacción",
		"description": "Ingrese el ID de registro para esta transacción. Puede encontrar la información en la declaración.",
		"recordIdLabel": "ID de registro",
		"cancelTitle": "Cancelar",
		"verifyTitle": "Verificar",
		"errors": {
			"recordIdRequired": "Se requiere identificación de registro",
			"recordIdInvalid": "El ID del registro debe tener 16 caracteres (letras o números), con el formato ABCD 1234 EFGH 5678",
			"verificationFailed": "No se pudo verificar la transacción. Por favor verifique el ID de registro"
		}
	},
	"errors": {
		"notFound": "Transacción no encontrada"
	}
}
